export default __webpack_public_path__ + "static/media/warning--winding-road-first-right--g2.53376994.png";